// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<polygon points="3,15.5 8.5,15.5 8.5,21 7.5,21 7.5,16.5 3,16.5" />
	<polygon points="7.5,7.5 3,7.5 3,8.5 8.5,8.5 8.5,3 7.5,3" />
	<polygon points="15.5,21 16.5,21 16.5,16.5 21,16.5 21,15.5 15.5,15.5" />
	<polygon points="16.5,7.5 16.5,3 15.5,3 15.5,8.5 21,8.5 21,7.5" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-minimize-Bnj0BCG7.js.map
